import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { isWCPledgeBasketEmptyAtom } from '@capsicum/features/world-championship-pledge/shared';
import { useAtomValue } from 'jotai';

import { useBaseWCPledgeGuard } from './useBaseWCPledgeGuard';

export const useWCPledgeConfirmationGuard: Guard = () => {
	const baseGuard = useBaseWCPledgeGuard();
	const router = useRouter();
	const isBasketEmpty = useAtomValue(isWCPledgeBasketEmptyAtom);

	return {
		onDenied: () => {
			if (baseGuard.status === 'denied') {
				baseGuard.onDenied();
			} else if (baseGuard.status === 'allowed' && isBasketEmpty) {
				router.push('/locker-room-internationals/basket');
			}
		},
		status: baseGuard.status === 'allowed' && !isBasketEmpty ? 'allowed' : 'denied'
	};
};
